/* eslint-disable import/prefer-default-export */

export const MODAL_SCREENS = {
  SALES: 'sales',
  CURRENCIES: 'currencies',
  COMMUNICATE_OPTIONS: 'communicate_options',
};

export const SALES_TABS = {
  SELL: 'sell',
  BUY: 'buy',
};

export const DEFAULT_SOURCE_CURRENCY = 'usdc';

export const DEFAULT_DESTINATION_CURRENCY = 'gbp';
